// extracted by mini-css-extract-plugin
export default {"container":"Info_container__9-2iu","label":"Info_label__-MGOM","value":"Info_value__GfiEq"};